import React, { Component } from "react";
import { ProductConsumer } from "../../context/context";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

export default class DinordreSendt extends Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { handleModalClose, modalOpen, clearCart } = value;
            return (
              <ModalGalleryWrapper>
                <Modal
                  size="lg"
                  show={modalOpen}
                  onHide={() => {
                    handleModalClose();
                    clearCart();
                  }}
                  dialogClassName="modal-90w"
                  aria-labelledby="example-custom-modal-styling-title"
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                      Din mad bliver gjort klar nu! Du kan hente den om 10–15
                      minutter.
                    </Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <p>
                      <strong>
                        Betal nemt i butikken: kort eller kontant.
                      </strong>
                    </p>

                    <div className="contaner center">
                      <Link
                        to="/"
                        onClick={() => {
                          handleModalClose();
                          clearCart();
                        }}
                        className="btn btn-primary btn-lg p-2"
                      >
                        ok
                      </Link>
                    </div>
                  </Modal.Body>
                </Modal>
              </ModalGalleryWrapper>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
const ModalGalleryWrapper = styled.div`
  .modal-backdrop.show {
    opacity: 0.8;
  }
`;
